import { APPS } from '@/commons/constants/apps';
import loggedUser from '@/commons/resources/loggedUser';

export const getAvailableApps = () =>
  [APPS.PAYMENTS, APPS.CONTACERTA].map(app => ({
    id: app.key,
    name: app.title,
    disabled: !loggedUser.hasApplicationAccess(app.key)
  }));
